<template>
  <div>
    <!-- Package &amp; Tour View -->
    <router-view :key="type + 'Container'"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      type: this.$route.name.startsWith('Private/Package') ? 'package' : 'tour'
    }
  }
}
</script>
